export const GET_SAS = 'GET_SAS'

export const getSasToken = (customerid) => ({
  type: GET_SAS,
  payload: {
    request: {
      mode: 'no-cors',
      url: `sastoken?customerid=${customerid}`,
      method: 'GET'
    }
  }
})



// WEBPACK FOOTER //
// ./src/redux/actions/blobActions.js